import * as React from 'react';

const SvgAiraTitleBar = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="url(#paint0_linear_672_6835)" />
        <g clipPath="url(#clip0_672_6835)">
            <path d="M15.5 10.5L16.125 9.125L17.5 8.5L16.125 7.875L15.5 6.5L14.875 7.875L13.5 8.5L14.875 9.125L15.5 10.5ZM11.75 10.75L10.5 8L9.25 10.75L6.5 12L9.25 13.25L10.5 16L11.75 13.25L14.5 12L11.75 10.75ZM15.5 13.5L14.875 14.875L13.5 15.5L14.875 16.125L15.5 17.5L16.125 16.125L17.5 15.5L16.125 14.875L15.5 13.5Z" fill="white" />
        </g>
        <defs>
            <linearGradient id="paint0_linear_672_6835" x1="4.90909" y1="0" x2="29.4545" y2="0" gradientUnits="userSpaceOnUse">
                <stop offset="0.255" stopColor="#6268FF" />
                <stop offset="1" stopColor="#3BA7FF" />
            </linearGradient>
            <clipPath id="clip0_672_6835">
                <rect width="12" height="12" fill="white" transform="translate(6 6)" />
            </clipPath>
        </defs>
    </svg>


)

export default SvgAiraTitleBar;